import { render, staticRenderFns } from "./InputActivity.vue?vue&type=template&id=50b72e76&scoped=true"
import script from "./InputActivity.vue?vue&type=script&lang=js"
export * from "./InputActivity.vue?vue&type=script&lang=js"
import style0 from "./InputActivity.vue?vue&type=style&index=0&id=50b72e76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b72e76",
  null
  
)

export default component.exports